import requestApi from './http'


// 封装请求接口
export const requestMethods = (url, type, data) => {
  return requestApi({
    url: url,
    method: type,
    data: data
  })
}



//////////////////
// WEBPACK FOOTER
// ./libs/api.js
// module id = null
// module chunks = 